module.exports = __webpack_public_path__ + "static/img/vipJh.53fce0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/vipJh.png
// module id = Vtbh
// module chunks = 1